/**
 * React Query provider with a single shared QueryClient.
 */

import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export function AppQueryProvider(props: {
  readonly children: React.ReactNode;
}): React.ReactElement {
  return <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>;
}
